import _sfc_main from "./ImageZoom2.mjs";
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, createVNode, Transition, withCtx, createCommentVNode, withDirectives, createTextVNode, toDisplayString, vShow } from "vue";
/* empty css            */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.mjs";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  ref: "imageScroller",
  class: "image-zoom__content"
};
const _hoisted_3 = ["src", "title"];
const _hoisted_4 = {
  key: 0,
  class: "image-zoom__loading"
};
const _hoisted_5 = {
  class: "image-zoom__controls"
};
const _hoisted_6 = {
  ref: "zoomText",
  "aria-live": "polite",
  class: "image-zoom__zoom-level"
};
const _hoisted_7 = {
  key: 0,
  class: "image-zoom__caption-wrapper"
};
const _hoisted_8 = {
  class: "image-zoom__caption-text"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_compass_spinner = resolveComponent("compass-spinner");
  const _component_icon_plus_lg = resolveComponent("icon-plus-lg");
  const _component_cdr_button = resolveComponent("cdr-button");
  const _component_icon_minus_lg = resolveComponent("icon-minus-lg");
  return openBlock(), createElementBlock("div", {
    ref: "zoomContainer",
    class: normalizeClass(["image-zoom", {
      "image-zoom--grabbable": _ctx.zoomLevel > 1,
      "image-zoom--moving": _ctx.zoomLevel > 1 && _ctx.isMouseDown
    }]),
    tabindex: "-1",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": _ctx.getHelperText,
    onKeydown: _cache[1] || (_cache[1] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args)),
    onMousedown: _cache[2] || (_cache[2] = (...args) => _ctx.handleMouseDown && _ctx.handleMouseDown(...args)),
    onMouseup: _cache[3] || (_cache[3] = (...args) => _ctx.handleMouseUp && _ctx.handleMouseUp(...args)),
    onWheel: _cache[4] || (_cache[4] = (...args) => _ctx.handleWheel && _ctx.handleWheel(...args))
  }, [createElementVNode("div", _hoisted_2, [createElementVNode("img", {
    ref: "image",
    class: normalizeClass(["image-zoom__image", {
      "image-zoom__image--disable-animation": _ctx.disableAnimation,
      "image-zoom__image--moving": _ctx.isMouseDown
    }]),
    draggable: "false",
    src: _ctx.imageSrc,
    alt: "",
    title: _ctx.getHelperText,
    style: normalizeStyle({
      transform: `scale3d(${_ctx.zoomLevel}, ${_ctx.zoomLevel}, ${_ctx.zoomLevel}) translate3d(${_ctx.left}px, ${_ctx.top}px, 0)`
    }),
    onLoad: _cache[0] || (_cache[0] = (...args) => _ctx.handleLoad && _ctx.handleLoad(...args))
  }, null, 46, _hoisted_3), createVNode(Transition, {
    name: "spinner-fade",
    "after-enter": "spinnerVisible"
  }, {
    default: withCtx(() => [_ctx.isLoading ? (openBlock(), createElementBlock("div", _hoisted_4, [createVNode(_component_compass_spinner, {
      class: "image-zoom__loading-spinner"
    })])) : createCommentVNode("", true)]),
    _: 1
  }), createElementVNode("div", _hoisted_5, [createVNode(Transition, {
    name: "zoomlevel"
  }, {
    default: withCtx(() => [withDirectives(createElementVNode("div", _hoisted_6, [_cache[5] || (_cache[5] = createElementVNode("span", {
      class: "pdp-sr-only"
    }, "Image zoomed to", -1)), createTextVNode(" " + toDisplayString((_ctx.zoomLevel * 100).toFixed(0)) + "% ", 1)], 512), [[vShow, _ctx.showZoomLevel]])]),
    _: 1
  }), createVNode(_component_cdr_button, {
    ref: "zoomIn",
    "aria-label": "Zoom in on image",
    class: "image-zoom__button",
    "icon-only": true,
    "with-background": true,
    disabled: _ctx.zoomLevel === _ctx.maxZoom,
    onClick: _ctx.clickPlus
  }, {
    default: withCtx(() => [createVNode(_component_icon_plus_lg)]),
    _: 1
  }, 8, ["disabled", "onClick"]), createVNode(_component_cdr_button, {
    ref: "zoomOut",
    "aria-label": "Zoom out on image",
    class: "image-zoom__button",
    "icon-only": true,
    "with-background": true,
    disabled: _ctx.zoomLevel === _ctx.minZoom,
    onClick: _ctx.clickMinus
  }, {
    default: withCtx(() => [createVNode(_component_icon_minus_lg)]),
    _: 1
  }, 8, ["disabled", "onClick"])]), _ctx.imageCaption ? (openBlock(), createElementBlock("div", _hoisted_7, [createElementVNode("span", _hoisted_8, toDisplayString(_ctx.imageCaption), 1)])) : createCommentVNode("", true)], 512)], 42, _hoisted_1);
}
const ImageZoom = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-e51c463b"]]);
export {
  ImageZoom as default
};
//# sourceMappingURL=ImageZoom.mjs.map
